<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	
	export default {
		name: 'App',
		
	};
</script>

<style>
    #app{
        width: 100%;
        height: 100%;
    }
	body{margin:0;}
	.bold{font-weight:bold;}
	.center{text-align:center;}
	.right{float:right;}
	.success {color: #67C23A;}
	.error {
		color: #F56C6C;
	}
	.offline {
		color: #909399;
	}
    .mint-header, .mint-button--primary {
        background-color: #2c4671;
    }
    .mint-tabbar > .mint-tab-item.is-selected {
        color: #2c4671;
    }
</style>